export default "__VITE_ASSET__DaKm$jBO__"